export const TAG = 'Settings';

export enum SettingsTabId {
  Appearance = 'appearance',
  Security = 'security',
}
